import { Link } from 'react-router-dom';

const footerSections = [
  {
    title: '快速导航',
    links: [
      { name: '首页', path: '/' },
      { name: '下载教程', path: '/category/xiazai-jiaocheng' },
      { name: '功能介绍', path: '/category/gongneng-jieshao' },
      { name: '使用技巧', path: '/category/shiyong-jiqiao' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { name: '常见问题', path: '/category/changjian-wenti' },
      { name: '更新日志', path: '/category/gengxin-rizhi' },
      { name: '安全隐私', path: '/category/anquan-yinsi' },
      { name: '关于我们', path: '/about' },
    ],
  },
  {
    title: '联系方式',
    links: [
      { name: '官方邮箱：support@kuaimaoapp.com', path: 'mailto:support@kuaimaoapp.com' },
      { name: '客服热线：400-123-4567', path: 'tel:4001234567' },
      { name: '微信公众号：快猫官方', path: '#' },
      { name: '官方微博：@快猫app', path: '#' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-smartphone-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-950">
                快猫app
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              快猫app是一款集智能推荐、多端同步、隐私安全于一体的综合性移动应用，致力于为用户提供最优质的移动体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-video-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer"
                  aria-label="社交媒体"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerSections.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.name}>
                    {link.path.startsWith('http') || link.path.startsWith('mailto') || link.path.startsWith('tel') ? (
                      <a
                        href={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} 快猫app 版权所有 | 
            <a href="#" className="hover:text-foreground-700 transition-colors ml-2">隐私政策</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-foreground-700 transition-colors">用户协议</a>
            <span className="mx-2">|</span>
            <a href="#" className="hover:text-foreground-700 transition-colors">Cookie设置</a>
          </p>
          <p className="text-sm text-foreground-500">
            沪ICP备2024000000号-1
          </p>
        </div>
      </div>
    </footer>
  );
}